var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    { attrs: { size: "small" } },
    [
      _c(
        "el-form-item",
        [
          _c(
            "el-radio",
            {
              attrs: { label: 6 },
              model: {
                value: _vm.radioValue,
                callback: function ($$v) {
                  _vm.radioValue = $$v
                },
                expression: "radioValue",
              },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("ChannelManagement.cron.Specify")) + " "
              ),
              _c("BjSelectLov", {
                attrs: { "option-list": _vm.WEEK_LIST, multiple: "" },
                model: {
                  value: _vm.checkboxList,
                  callback: function ($$v) {
                    _vm.checkboxList = $$v
                  },
                  expression: "checkboxList",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }